import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const AdminPanel = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [userName, setUserName] = useState("");
  const [userFullName, setUserFullName] = useState("");

  useEffect(() => {
    const storedUserType = localStorage.getItem("usertype");
    const storedUserName = localStorage.getItem("userName");
    const storedFName = localStorage.getItem("fname");
    const storedLName = localStorage.getItem("lname");

    if (!storedUserType) {
      navigate("/sign-in");
    } else {
      setUserType(storedUserType);
      setUserName(storedUserName);
      if (storedFName && storedLName) {
        setUserFullName(`${storedFName} ${storedLName}`);
      } else if (storedFName) {
        setUserFullName(storedFName);
      } else {
        setUserFullName(storedUserName);
      }
    }
  }, [navigate]);


  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("userName");
    localStorage.removeItem("usertype");
    localStorage.removeItem("fname");
    localStorage.removeItem("lname");
    navigate("/sign-in");
  };

  // Debugging: Log the imported components to check their validity
  console.log("AdminSidebar:", AdminSidebar);
  console.log("AdministratorSidebar:", AdministratorSidebar);
  console.log("UserSidebar:", UserSidebar);

  return (
    <div className="admin-container">
      <div className="sidebar-container">
        {userType === "administrator" && <AdministratorSidebar />}
        {userType === "admin" && <AdminSidebar />}
        {userType === "user" && <UserSidebar />}
      </div>

      <div className="admin-content">
        <div className="admin-navbar">
          <h1 className="welcome-text">Welcome to the Admin Panel, {userFullName}</h1>
          <button onClick={logout} className="logout-btn btn btn-warning">
            Logout
          </button>
        </div>

        <div className="main-section">
          <h3 className="section-title">Dashboard Overview</h3>

          <div className="summary-table">
            <h4 className="table-title">Inventory Summary</h4>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Vehicles</td>
                  <td>Comming Soon</td>
                </tr>
                <tr>
                  <td>Sold Vehicles</td>
                  <td>Comming Soon</td>
                </tr>
                <tr>
                  <td>Remaining Vehicles</td>
                  <td>Comming Soon</td>
                </tr>
                <tr>
                  <td>Total Sales Amount</td>
                  <td>Comming Soon</td>
                </tr>
                <tr>
                  <td>Remaining Stock Amount</td>
                  <td>Comming Soon</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;